import React from 'react';
import { BrandIcon, Pill, Accordion } from '../../ui/common';
import type { AgentItem } from '../../domain/types';

type InspectorVariant = 'docked' | 'sheet';

export const InspectorAgentPanel: React.FC<{
  agent: AgentItem;
  variant: InspectorVariant;
  onClose: () => void;
}> = ({ agent, variant, onClose }) => (
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 2,
        padding: '15px 46px 13px 18px',
        background: 'var(--z-surface)',
        backdropFilter: 'blur(16px)',
        borderBottom: 'none',
      }}
    >
      <button
        type="button"
        data-testid="inspector-close"
        aria-label={variant === 'sheet' ? 'Back to list' : 'Clear selection'}
        onClick={onClose}
        style={{
          position: 'absolute',
          top: 12,
          right: 12,
          width: 36,
          height: 36,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: 'var(--z-muted-2)',
          background: 'var(--z-fill-2)',
          border: 'none',
          zIndex: 3,
        }}
      >
        ✕
      </button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 9 }}>
        <BrandIcon source="agents" size={16} />
        <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11.5, fontWeight: 600, color: 'var(--z-muted-2)' }}>
          {agent.name}
        </span>
        <Pill label={agent.state} tone={agent.running ? 'ok' : 'warn'} />
        <span style={{ fontSize: 11.5, color: 'var(--z-faint)' }}>{agent.elapsed}</span>
      </div>
      <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, lineHeight: 1.35, letterSpacing: '-0.02em', color: 'var(--z-text)' }}>
        {agent.last}
      </h2>
    </div>

    <div style={{ padding: '15px 18px 34px', display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Accordion title="Resumen de Zunelo" defaultOpen={true}>
        <p style={{ margin: 0, fontSize: 13, lineHeight: 1.6, color: 'var(--z-accent-copy)', textWrap: 'pretty' }}>
          El agente está trabajando sobre <strong>{agent.ticket}</strong> en la rama <code>{agent.branch}</code>.
          {agent.running ? ' Sigue en ejecución activa generando código y tests.' : ' Está en pausa esperando instrucciones o credenciales.'}
        </p>
      </Accordion>
    </div>
  </div>
);
